import strings from "../../i18n/definitions";

export const timePeriodMap = {
  7: strings.oneWeek,
  14: strings.twoWeeks,
  30: strings.oneMonth,
  182: strings.sixMonths,
  365: strings.oneYear,
};
